import React, { useState, useRef } from 'react';

const Tooltip = ({ children, content, className = '', block = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [coords, setCoords] = useState({ bottom: 0, left: 0 });
  const wrapperRef = useRef(null);

  const show = () => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setCoords({ bottom: window.innerHeight - rect.top + 5, left: rect.left + rect.width / 2 });
    }
    setIsVisible(true);
  };

  const hide = () => setIsVisible(false);

  return (
    <div ref={wrapperRef} className={`relative ${block ? 'block' : 'inline-block'}`}>
      <div
        onMouseEnter={show}
        onMouseLeave={hide}
        onTouchStart={show}
        onTouchEnd={() => setTimeout(hide, 1500)}
        onTouchCancel={hide}
        className={className}
      >
        {children}
      </div>
      {isVisible && (
        <div
          className="fixed z-[9999] px-3 py-2 text-sm text-white bg-slate-800 rounded-md shadow-lg pointer-events-none whitespace-nowrap"
          style={{ bottom: coords.bottom, left: coords.left, transform: 'translateX(-50%)' }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;